// import { IoCloseCircleOutline } from "react-icons/io5";
// import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import BellNoiseIcon from "../icons/BellNoiseIcon";
import { useState } from "react";
import CheckIcon from "../icons/CheckIcon";
import CloseIcon from "../icons/CloseIcon";

const Marketing = ({ selected, setSelected, locale }) => {
  const [open, setOpen] = useState(false);
  return (
    <li
      onClick={() => setSelected(1)}
      className={`flex items-center justify-between xs:justify-start gap-2 p-1.5 border ${
        selected === 1 && "border-primary-900"
      } rounded-md cursor-pointer`}
    >
      <span className="flex flex-col items-center justify-center">
        <span
          className={`flex ${
            open ? "flex-row" : "flex-row-reverse"
          } items-center`}
          onClick={() => setOpen(!open)}
        >
          <hr
            className={`w-4 border ${
              open ? "border-green-600" : "border-red-600"
            }`}
          />
          {open ? (
            <span className="grid border border-green-600 rounded-full size-5 place-items-center">
              <CheckIcon className="text-green-600 size-2" />
            </span>
          ) : (
            <span className="grid border border-red-600 rounded-full size-5 place-items-center">
              <CloseIcon className="text-red-600 size-2" />
            </span>
          )}
        </span>
      </span>
      <span className="flex items-center justify-center gap-1 flex-1">
        <BellNoiseIcon className="w-4 h-4" />
        <span>{locale === "en" ? "Marketing" : "التسويق"}</span>
      </span>
    </li>
  );
};

export default Marketing;
